module.exports = __webpack_public_path__ + "static/img/ic_gps@2x.bea4a09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_gps@2x.png
// module id = mGcf
// module chunks = 1